import { render, staticRenderFns } from "./viewOrderInfo.vue?vue&type=template&id=225dc80e&scoped=true&"
import script from "./viewOrderInfo.vue?vue&type=script&lang=js&"
export * from "./viewOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./viewOrderInfo.vue?vue&type=style&index=0&id=225dc80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225dc80e",
  null
  
)

export default component.exports